import React, { memo } from 'react'

import { Divider } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

import ActionPreview from './Components/ActionPreview/ActionPreview'
import CollapsedAIEngineRow from './Components/CollapsedAIEngineRow/CollapsedAIEngineRow'
import CollapsedMaterialRow from './Components/CollapsedMaterialRow/CollapsedMaterialRow'
import CollapsedPolyCountRow from './Components/CollapsedPolyCountRow/CollapsedPolyCountRow'
import CollapsedPolygonTypeRow from './Components/CollapsedPolygonTypeRow/CollapsedPolygonTypeRow'
import CollapsedSmartLowPolyRow from './Components/CollapsedSmartLowPolyRow/CollapsedSmartLowPolyRow'
import CollapsedUseCaseRow from './Components/CollapsedUseCaseRow/CollapsedUseCaseRow'

function CollapsedModelSettings() {
  const isSmartLowPoly = useThreeDStudioStore(state => state.modelSettings.isSmartLowPoly)

  return (
    <div className="collapsed-model-settings">
      <ActionPreview />
      <CollapsedUseCaseRow />
      <Divider />
      <CollapsedAIEngineRow />
      <CollapsedSmartLowPolyRow />
      {/* Topology is the only setting the low-poly models drop - P1 has no quad mode. */}
      {!isSmartLowPoly && <CollapsedPolygonTypeRow />}
      <CollapsedPolyCountRow />
      <CollapsedMaterialRow />
    </div>
  )
}

export default memo(CollapsedModelSettings)
